export function getAbsoluteUrl(url) {
  if (url.startsWith('http')) {
      return url;
  }
  const baseUrl = window.location.origin;
  return new URL(url, baseUrl).href;
};
